(function () {
  function isDebugEnabled() {
    try {
      if (typeof window === 'undefined') return false;
      var query = new URLSearchParams(window.location.search || '');
      if (query.get('personalizerDebug') === '1') return true;
      if (window.localStorage && window.localStorage.getItem('orion_personalizer_debug') === '1') return true;
    } catch (_error) {
      return false;
    }
    return false;
  }

  function toArray(value) {
    return Array.isArray(value) ? value : [];
  }

  function slugify(value, fallback) {
    const source = String(value || fallback || '').trim().toLowerCase();
    const slug = source
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
    return slug || fallback || 'item';
  }

  function toNumber(value, fallback) {
    if (typeof value === 'number' && Number.isFinite(value)) return value;
    if (typeof value === 'string') {
      const normalized = value.replace(',', '.').trim();
      const parsed = Number(normalized);
      if (Number.isFinite(parsed)) return parsed;
    }
    return fallback;
  }

  function normalizeMoneyValue(value) {
    const numeric = toNumber(value, 0);
    if (!numeric) return 0;

    if (!Number.isInteger(numeric)) {
      return Math.round(numeric * 100);
    }

    if (Math.abs(numeric) >= 1000) {
      return Math.round(numeric);
    }

    return Math.round(numeric * 100);
  }

  function normalizeCentsValue(value) {
    const numeric = toNumber(value, 0);
    if (!numeric) return 0;
    return Math.round(numeric);
  }

  function resolvePriceCents(item, centsKeys, majorKeys) {
    const centsList = toArray(centsKeys);
    for (let index = 0; index < centsList.length; index += 1) {
      const key = centsList[index];
      if (item[key] !== undefined && item[key] !== null && item[key] !== '') {
        return normalizeCentsValue(item[key]);
      }
    }

    const majorList = toArray(majorKeys);
    for (let index = 0; index < majorList.length; index += 1) {
      const key = majorList[index];
      if (item[key] !== undefined && item[key] !== null && item[key] !== '') {
        return normalizeMoneyValue(item[key]);
      }
    }

    return 0;
  }

  function normalizeTechniques(rawTechniques) {
    return toArray(rawTechniques).map(function (item, index) {
      if (typeof item === 'string') {
        return {
          id: slugify(item, 'technique-' + (index + 1)),
          label: item,
          priceCents: 0,
          zoneIds: []
        };
      }

      const label = item.label || item.name || ('Technique ' + (index + 1));
      return {
        id: item.id || slugify(label, 'technique-' + (index + 1)),
        label: label,
        priceCents: resolvePriceCents(item, ['price_cents', 'base_price_cents'], ['price', 'base_price']),
        colorMode: String(item.color_mode || item.colorMode || '').trim().toLowerCase(),
        sharedMarkingColor: item.shared_marking_color === true || item.sharedMarkingColor === true,
        feeProductHandle: String(item.fee_product_handle || item.feeProductHandle || '').trim(),
        feeVariantSku: String(item.fee_variant_sku || item.feeVariantSku || '').trim(),
        zoneIds: toArray(item.zone_ids || item.zones || item.techniques)
          .map(function (value) {
            return slugify(value, '');
          })
          .filter(Boolean)
      };
    });
  }

  function normalizeCustomizationRules(rawRules) {
    const rules = rawRules && typeof rawRules === 'object' && !Array.isArray(rawRules) ? rawRules : {};
    const rawMaxActiveZones = rules.max_active_zones ?? rules.maxActiveZones;
    const rawMinCustomizationQuantity = rules.min_customization_quantity ?? rules.minCustomizationQuantity;
    const rawVariantQuantityMode = String(rules.variant_quantity_mode ?? rules.variantQuantityMode ?? '').trim().toLowerCase();
    const splitOption = String(rules.split_option ?? rules.splitOption ?? '').trim();
    const maxActiveZones = Number(rawMaxActiveZones);
    const minCustomizationQuantity = Number(rawMinCustomizationQuantity);
    return {
      maxActiveZones: Number.isFinite(maxActiveZones) && maxActiveZones > 0 ? Math.floor(maxActiveZones) : null,
      minCustomizationQuantity:
        Number.isFinite(minCustomizationQuantity) && minCustomizationQuantity > 0
          ? Math.floor(minCustomizationQuantity)
          : null,
      variantQuantityMode: rawVariantQuantityMode === 'split' ? 'split' : 'single',
      splitOption: splitOption
    };
  }

  function normalizeZones(rawZones) {
    return toArray(rawZones).map(function (item, index) {
      if (typeof item === 'string') {
        return {
          id: slugify(item, 'zone-' + (index + 1)),
          label: item,
          priceCents: 0,
          techniqueIds: [],
          xPercent: 0,
          yPercent: 0,
          widthPercent: 100,
          heightPercent: 100,
          fullImage: false,
          view: 'front'
        };
      }

      const label = item.label || item.name || ('Zone ' + (index + 1));
      return {
        id: item.id || slugify(label, 'zone-' + (index + 1)),
        label: label,
        priceCents: resolvePriceCents(
          item,
          ['price_cents', 'supplement_cents', 'extra_price_cents'],
          ['price', 'supplement', 'extra_price']
        ),
        techniqueIds: toArray(item.technique_ids || item.techniques || item.technique)
          .map(function (value) {
            return slugify(value, '');
          })
          .filter(Boolean),
        xPercent: toNumber(item.x_percent ?? item.xPercent ?? item.x ?? 0, 0),
        yPercent: toNumber(item.y_percent ?? item.yPercent ?? item.y ?? 0, 0),
        widthPercent: toNumber(item.width_percent ?? item.widthPercent ?? item.width ?? 100, 100),
        heightPercent: toNumber(item.height_percent ?? item.heightPercent ?? item.height ?? 100, 100),
        offsetXPercent: toNumber(item.offset_x_percent ?? item.offsetXPercent ?? item.nudge_x_percent ?? item.nudgeXPercent ?? 0, 0),
        offsetYPercent: toNumber(item.offset_y_percent ?? item.offsetYPercent ?? item.nudge_y_percent ?? item.nudgeYPercent ?? 0, 0),
        previewScale: toNumber(item.preview_scale ?? item.previewScale ?? item.visual_scale ?? item.visualScale ?? 1, 1),
        forceSquare:
          item.force_square === true ||
          item.forceSquare === true ||
          item.square === true,
        view: String(item.view || item.side || 'front').toLowerCase() === 'back' ? 'back' : 'front',
        widthCm: toNumber(item.width_cm ?? item.widthCm ?? null, null),
        heightCm: toNumber(item.height_cm ?? item.heightCm ?? null, null),
        fullImage:
          item.full_image === true ||
          item.fullImage === true ||
          item.full_canvas === true ||
          item.fullCanvas === true ||
          String(item.kind || '').toLowerCase() === 'full-image',
        constraintGroup: slugify(item.constraint_group ?? item.constraintGroup ?? '', ''),
        exclusiveWith: toArray(item.exclusive_with ?? item.exclusiveWith)
          .map(function (value) {
            return slugify(value, '');
          })
          .filter(Boolean)
      };
    });
  }

  function normalizeMockups(rawMockups) {
    const mockups = {};

    if (!rawMockups) return mockups;

    if (Array.isArray(rawMockups)) {
      rawMockups.forEach(function (item) {
        if (!item) return;

        if (typeof item === 'string') {
          const key = slugify('default', 'default');
          mockups[key] = item;
          return;
        }

        const rawKey = item.key || item.color || item.color_name || item.option || item.name || 'default';
        const key = slugify(rawKey, 'default');
        const url = item.url || item.src || item.image || item.mockup || '';
        if (url) mockups[key] = url;
      });
      return mockups;
    }

    if (typeof rawMockups === 'object') {
      Object.keys(rawMockups).forEach(function (rawKey) {
        const key = slugify(rawKey, 'default');
        const value = rawMockups[rawKey];

        if (typeof value === 'string') {
          mockups[key] = value;
          return;
        }

        if (value && typeof value === 'object') {
          const url = value.url || value.src || value.image || value.mockup || '';
          if (url) mockups[key] = url;
        }
      });
    }

    return mockups;
  }

  function normalizeMockupAdjustments(rawAdjustments) {
    var rules = [];

    function pushRule(input, fallbackKey) {
      if (!input || typeof input !== 'object') return;

      var rawView = String(input.view || input.side || '').trim().toLowerCase();
      var normalizedView = rawView === 'front' || rawView === 'back' ? rawView : '';
      var rawColor = input.color || input.color_name || input.colorName || input.name || input.key || fallbackKey || '';
      var rawVariantId = input.variant_id || input.variantId || '';
      var zoom = toNumber(input.zoom, null);
      var offsetXRatio = toNumber(input.offset_x_ratio ?? input.offsetXRatio ?? input.offset_x ?? input.offsetX, null);
      var offsetYRatio = toNumber(input.offset_y_ratio ?? input.offsetYRatio ?? input.offset_y ?? input.offsetY, null);

      rules.push({
        key: slugify(rawColor, ''),
        variantId: rawVariantId !== null && rawVariantId !== undefined && rawVariantId !== '' ? String(rawVariantId) : '',
        view: normalizedView,
        zoom: zoom && zoom > 0 ? zoom : null,
        offsetXRatio: Number.isFinite(offsetXRatio) ? offsetXRatio : 0,
        offsetYRatio: Number.isFinite(offsetYRatio) ? offsetYRatio : 0
      });
    }

    function parseNestedRule(rawKey, value, forcedView) {
      if (!value) return;
      if (typeof value !== 'object') return;

      var hasDirectPlacementFields =
        value.zoom !== undefined ||
        value.offset_x_ratio !== undefined ||
        value.offsetXRatio !== undefined ||
        value.offset_y_ratio !== undefined ||
        value.offsetYRatio !== undefined ||
        value.variant_id !== undefined ||
        value.variantId !== undefined;

      if (hasDirectPlacementFields) {
        var payload = Object.assign({}, value);
        if (forcedView) payload.view = forcedView;
        if (!payload.key && !payload.color && !payload.color_name && !payload.colorName && rawKey) {
          payload.key = rawKey;
        }
        pushRule(payload, rawKey);
        return;
      }

      ['front', 'back'].forEach(function (view) {
        if (!value[view] || typeof value[view] !== 'object') return;
        var payload = Object.assign({}, value[view], { view: view, key: rawKey });
        pushRule(payload, rawKey);
      });
    }

    if (!rawAdjustments) return rules;

    if (Array.isArray(rawAdjustments)) {
      rawAdjustments.forEach(function (item) {
        pushRule(item, '');
      });
      return rules;
    }

    if (typeof rawAdjustments === 'object') {
      Object.keys(rawAdjustments).forEach(function (rawKey) {
        parseNestedRule(rawKey, rawAdjustments[rawKey], '');
      });
    }

    return rules;
  }

  function getAvailableColors(rawColors) {
    function toScalarString(value) {
      if (value === null || value === undefined) return '';
      if (typeof value === 'string' || typeof value === 'number') return String(value).trim();
      if (typeof value !== 'object') return '';

      var direct = value.value;
      if (typeof direct === 'string' || typeof direct === 'number') return String(direct).trim();

      var nestedKeys = ['hex', 'color', 'code', 'name', 'label', 'title'];
      for (var i = 0; i < nestedKeys.length; i += 1) {
        var nested = value[nestedKeys[i]];
        if (typeof nested === 'string' || typeof nested === 'number') return String(nested).trim();
        if (nested && typeof nested === 'object') {
          var nestedValue = nested.value;
          if (typeof nestedValue === 'string' || typeof nestedValue === 'number') return String(nestedValue).trim();
        }
      }
      return '';
    }

    function pickFirst(item, keys) {
      for (var i = 0; i < keys.length; i += 1) {
        var key = keys[i];
        if (!item || item[key] === undefined || item[key] === null) continue;
        var scalar = toScalarString(item[key]);
        if (scalar) return scalar;
      }

      var fields = item && item.fields;
      if (Array.isArray(fields)) {
        for (var fieldIndex = 0; fieldIndex < fields.length; fieldIndex += 1) {
          var field = fields[fieldIndex];
          if (!field || typeof field !== 'object') continue;
          var fieldKey = String(field.key || field.name || field.id || '').trim().toLowerCase();
          if (!fieldKey) continue;
          for (var keyIndex = 0; keyIndex < keys.length; keyIndex += 1) {
            if (fieldKey !== String(keys[keyIndex]).toLowerCase()) continue;
            var fieldScalar = toScalarString(field.value !== undefined ? field.value : field);
            if (fieldScalar) return fieldScalar;
          }
        }
      }
      return '';
    }

    function normalizeSwatchColor(value) {
      var raw = toScalarString(value);
      if (!raw) return '';

      if (/^[0-9a-fA-F]{3}$/.test(raw) || /^[0-9a-fA-F]{4}$/.test(raw) || /^[0-9a-fA-F]{6}$/.test(raw) || /^[0-9a-fA-F]{8}$/.test(raw)) {
        return '#' + raw;
      }
      if (/^#[0-9a-fA-F]{3}$/.test(raw) || /^#[0-9a-fA-F]{4}$/.test(raw) || /^#[0-9a-fA-F]{6}$/.test(raw) || /^#[0-9a-fA-F]{8}$/.test(raw)) {
        return raw;
      }
      if (typeof window !== 'undefined' && window.CSS && typeof window.CSS.supports === 'function') {
        return window.CSS.supports('color', raw) ? raw : '';
      }
      return '';
    }

    var normalized = toArray(rawColors)
      .map(function (item, index) {
        if (!item) return null;

        if (typeof item === 'string') {
          return {
            id: slugify(item, 'color-' + (index + 1)),
            name: item,
            swatchHex: '',
            mockupFront: '',
            mockupBack: ''
          };
        }

        const name = pickFirst(item, ['name', 'label', 'title', 'color']) || ('Couleur ' + (index + 1));
        const swatchHex = normalizeSwatchColor(
          pickFirst(item, [
            'hex',
            'color_hex',
            'colorHex',
            'swatch_hex',
            'swatchHex',
            'swatch',
            'code',
            'colour',
            'colour_hex',
            'colourHex',
            'hex_color',
            'hexColor',
            'couleur_hex',
            'couleurHex'
          ])
        );
        return {
          id: pickFirst(item, ['id', 'key', 'handle']) || slugify(name, 'color-' + (index + 1)),
          name: name,
          swatchHex: swatchHex,
          mockupFront: pickFirst(item, ['mockup_front', 'front', 'mockup', 'url']),
          mockupBack: pickFirst(item, ['mockup_back', 'back'])
        };
      })
      .filter(Boolean);

    if (isDebugEnabled() && typeof console !== 'undefined' && typeof console.groupCollapsed === 'function') {
      console.groupCollapsed('[Personalizer Colors] metafields-normalized');
      if (typeof console.log === 'function') {
        console.log({
          rawColors: rawColors,
          normalizedColors: normalized
        });
      }
      if (typeof console.groupEnd === 'function') console.groupEnd();
    }

    return normalized;
  }

  function getMockupForColor(colorName, view, colors) {
    const normalizedName = slugify(colorName, '');
    const normalizedView = String(view || 'front').toLowerCase() === 'back' ? 'back' : 'front';
    const colorList = toArray(colors);

    if (!normalizedName || colorList.length === 0) return '';

    const match = colorList.find(function (colorItem) {
      return slugify(colorItem.name, '') === normalizedName;
    });

    if (!match) return '';

    if (normalizedView === 'back' && match.mockupBack) return match.mockupBack;
    if (match.mockupFront) return match.mockupFront;
    if (match.mockupBack) return match.mockupBack;
    return '';
  }

  function getMockupAdjustment(adjustments, colorName, view, variant) {
    var rules = toArray(adjustments);
    if (!rules.length) return null;

    var normalizedView = String(view || 'front').toLowerCase() === 'back' ? 'back' : 'front';
    var colorKey = slugify(colorName, '');
    var variantId = variant && variant.id ? String(variant.id) : '';

    function matchRule(predicate) {
      for (var index = 0; index < rules.length; index += 1) {
        var rule = rules[index];
        if (!rule || typeof rule !== 'object') continue;
        if (predicate(rule)) return rule;
      }
      return null;
    }

    var matchedRule =
      (variantId &&
        matchRule(function (rule) {
          return rule.variantId === variantId && rule.view === normalizedView;
        })) ||
      (variantId &&
        matchRule(function (rule) {
          return rule.variantId === variantId && !rule.view;
        })) ||
      (colorKey &&
        matchRule(function (rule) {
          return rule.key === colorKey && rule.view === normalizedView;
        })) ||
      (colorKey &&
        matchRule(function (rule) {
          return rule.key === colorKey && !rule.view;
        })) ||
      matchRule(function (rule) {
        return rule.key === 'default' && rule.view === normalizedView;
      }) ||
      matchRule(function (rule) {
        return rule.key === 'default' && !rule.view;
      });

    if (!matchedRule) return null;

    return {
      zoom: matchedRule.zoom && matchedRule.zoom > 0 ? matchedRule.zoom : null,
      offsetXRatio: Number.isFinite(matchedRule.offsetXRatio) ? matchedRule.offsetXRatio : 0,
      offsetYRatio: Number.isFinite(matchedRule.offsetYRatio) ? matchedRule.offsetYRatio : 0
    };
  }

  function getColorOptionIndex(options) {
    const list = toArray(options);
    return list.findIndex(function (name) {
      const normalized = String(name || '').toLowerCase();
      return normalized.includes('color') || normalized.includes('couleur');
    });
  }

  function getVariantColorValue(variant, options) {
    if (!variant) return '';
    const colorIndex = getColorOptionIndex(options);

    if (colorIndex < 0 || !Array.isArray(variant.options)) {
      return '';
    }

    return String(variant.options[colorIndex] || '').trim();
  }

  function getMockupUrl(mockupMap, variant, options, fallbackUrl) {
    const variantIdKey = variant && variant.id ? String(variant.id) : '';
    if (variantIdKey && mockupMap[variantIdKey]) return mockupMap[variantIdKey];

    const colorValue = getVariantColorValue(variant, options);
    const colorKey = slugify(colorValue, '');

    if (colorKey && mockupMap[colorKey]) return mockupMap[colorKey];
    if (mockupMap.default) return mockupMap.default;

    const firstKey = Object.keys(mockupMap)[0];
    if (firstKey) return mockupMap[firstKey];

    return fallbackUrl || '';
  }

  function getAvailableZones(zones, selectedTechnique) {
    const zoneList = toArray(zones);
    if (!selectedTechnique) return zoneList;

    return zoneList.filter(function (zone) {
      const zoneTechniqueIds = toArray(zone.techniqueIds);
      return zoneTechniqueIds.length === 0 || zoneTechniqueIds.includes(selectedTechnique.id);
    });
  }

  window.PersonalizerMetafields = {
    normalizeMoneyValue: normalizeMoneyValue,
    normalizeTechniques: normalizeTechniques,
    normalizeZones: normalizeZones,
    normalizeCustomizationRules: normalizeCustomizationRules,
    normalizeMockups: normalizeMockups,
    normalizeMockupAdjustments: normalizeMockupAdjustments,
    getAvailableColors: getAvailableColors,
    getMockupForColor: getMockupForColor,
    getMockupAdjustment: getMockupAdjustment,
    getColorOptionIndex: getColorOptionIndex,
    getVariantColorValue: getVariantColorValue,
    getMockupUrl: getMockupUrl,
    getAvailableZones: getAvailableZones
  };
})();
